import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  AfterViewInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-search-map",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.scss"],
})
export class SearchMapComponent implements OnInit, AfterViewInit {
  //@ViewChild('inputSearch') inputSearch: ElementRef;
  @ViewChild("inputSearch", { static: true }) inputSearch: ElementRef;

  element = null;

  constructor(private translate: TranslateService) {}

  ngOnInit() {}

  ngAfterViewInit() {
    this.element = this.inputSearch.nativeElement;
  }
}
